module.exports = __webpack_public_path__ + "static/media/HEC.c27de5a7.png";